export const nightsDataSource = new Array(18).fill(1).map((v, i) => `${i + 4}`);
